var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FilePicker',{attrs:{"allow-pick-directory":"","buttons":_vm.buttons,"container":null,"name":_vm.t('files', 'Select file or folder to link to'),"multiselect":false},on:{"close":_vm.onClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }